import {Auth} from 'aws-amplify';

export const DRM_TOKEN_START = 'DRM_TOKEN_START';
export const DRM_TOKEN_SUCCESS = 'DRM_TOKEN_SUCCESS';
export const DRM_TOKEN_ERROR = 'DRM_TOKEN_ERROR';

export const loadDRMToken = (videoId, tokenId) => async (
    dispatch,
    getState,
) => {
    let {config, user} = getState();

    dispatch({type: DRM_TOKEN_START, id: videoId});

    let url = `${(config.catalog_settings &&
        config.catalog_settings.endpoint) ||
        'https://avs-proxy.dev.aaa.wmgp.io/v1'}/${
        tokenId ? 'R' : 'A'
    }/${user.catalogLanguage || 'spa'}/${(config.catalog_settings &&
        config.catalog_settings.platforms[0]) ||
        'PCTV_DASH'}/${user.catalogTenant ||
        'CNPLUS_LATAM_LATAM'}/CONTENT/GETDRMTOKEN/${videoId}`;

    let headers = new Headers();

    tokenId = await Auth.currentSession()
        .then(res => {
            return res.getIdToken().getJwtToken();
        })
        .catch(err => {
            return tokenId;
        });

    headers.append('Authorization', `Bearer ${tokenId}`);

    fetch(url, {headers})
        .then(res => {
            if (!res.ok) {
                throw new Error('DRM request failed');
            }
            return res.json();
        })
        .then(res => {
            if (res.resultCode !== 'OK') {
                throw new Error(res.message);
            }
            dispatch({
                type: DRM_TOKEN_SUCCESS,
                payload: res.resultObj,
                id: videoId,
            });
        })
        .catch(error => {
            dispatch({type: DRM_TOKEN_ERROR, error, id: videoId});
            throw new Error(error);
        });
};
